import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {deleteUserStatus, fetchUserStatus, resetUserStatus} from "../../../../creators/user.status";

import Avatar from '../../Avatar';
import Answers from '../../Answers';
import Report from '../../Report';
import DateSince from '../../Date';
import Dropdown from "../../Dropdown";
import EditStatus from './EditStatus';
import Alert from '../../Alert';
import Icon from '../../Icon';
import {Can} from "../../../../ability-context";
import Modal from "../../Modal";
import createLink from "../../../../libs/createLink";
import Like from "../../Like/Like";
import TimelineComments from "../../comments/TimelineComments";
import {reportStatusComment, reportUserStatus} from "../../../../creators/report";
import DraftContentReader from "../../editor/DraftContentReader";
import ViewMore from "../../ViewMore";
import {SpinLoader} from "../../Loader";
import {isNoFollowProfil} from "../../../../libs/helper";


class CardStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editStatus: false,
            toggleAlertDelete: false,
            deleteLoading: false,
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleReportComment = this.handleReportComment.bind(this);
        this.editorRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.parentId.contentRaw !== this.props.parentId.contentRaw){
            this.editorRef.current.updateContent(this.props.parentId.contentRaw);
        }
    }

    componentWillUnmount() {
        this.setState({editStatus: false, toggleAlertDelete: false});
        this.props.resetUserStatus();
    }

    handleDelete() {
        this.props.deleteUserStatus(this.props.parentId.author._id, this.props.parentId._id);
        this.setState({toggleAlertDelete: false, deleteLoading: true});
    }

    handleReport(message){
        // this.props.reportUserStatus(this.props.owner._id, this.props.parentId._id, {message})
        this.props.reportUserStatus(this.props.parentId._id, {message})
    }

    handleReportComment(id, message){
        this.props.reportStatusComment(this.props.parentId._id, id, {message})
    }

    render() {
        let limitHeight = 17 * 20;
        let relLinkProfilAuthor = isNoFollowProfil(this.props.parentId.author) ? { rel: "nofollow" } : {};
        let relLinkProfil = isNoFollowProfil(this.props.parentId.owner) ? { rel: "nofollow" } : {};

        return (
            <div className="card card-status">
                    <Fragment>
                        <div className="wrapper">
                            <div className="topline">
                                <div className="row avatar-userstatus">
                                    {this.props.parentId.author && this.props.parentId.author._id ? (
                                        <Link className="wrapper-avatar"
                                              to={createLink("userProfile", this.props.parentId.author)} {...relLinkProfilAuthor}>
                                            <Avatar
                                                avatar={this.props.parentId.author && this.props.parentId.author.profile.avatar}
                                                gender={this.props.parentId.author ? this.props.parentId.author.profile.gender : "guest"}
                                                alt=""/>
                                        </Link>
                                    ) : (
                                        <Avatar
                                            avatar={this.props.parentId.author && this.props.parentId.author.profile.avatar}
                                            gender={this.props.parentId.author ? this.props.parentId.author.profile.gender : "guest"}
                                            alt=""/>
                                    )}
                                    <div className="username row wrap">
                                        {this.props.parentId.author && this.props.parentId.author._id ? (
                                        <Link
                                            to={createLink("userProfile", this.props.parentId.author)} {...relLinkProfilAuthor}>
                                            {this.props.parentId.author.username}
                                        </Link>) : (
                                            <div>{this.props.parentId.authorName}</div>
                                        )}
                                        &nbsp;
                                        {this.props.parentId.author && this.props.parentId.author._id !== this.props.parentId.owner._id && `a publié sur ${this.props.parentId.owner.username === this.props.currentUserUsername ? "votre mur" : "le mur de"}`}
                                        &nbsp;
                                        {this.props.parentId.author && this.props.parentId.author._id !== this.props.parentId.owner._id && (
                                            <Link
                                                to={createLink("userProfile", this.props.parentId.owner)} {...relLinkProfil}>{this.props.parentId.owner.username}</Link>)}

                                        <span className="text small medium-grey date full">
                                            <DateSince
                                                date={this.props.createdAt}
                                                prefix={true}
                                                currentFormat={true}
                                            />
                                        </span>
                                    </div>
                                </div>
                                {this.state.deleteLoading ? (
                                    <div className={"dropdown mt-4"}>
                                        <SpinLoader className={"small"}/>
                                    </div>
                                ) : (
                                    this.props.currentUserUsername ? (
                                            <Dropdown align="right" className="mt-4" activableComponent={(
                                                <Icon type="vertical-dots"/>
                                            )}>
                                                <ul className="dropdown-menu">
                                                    <Can action={"update"} subject={this.props.parentId} modelName="Status">
                                                        <li className="menu-item"
                                                            onClick={() => this.setState({editStatus: true})}>
                                                            <Icon type="pencil"/> Editer
                                                        </li>
                                                    </Can>
                                                    <Can action={"delete"} subject={this.props.parentId} modelName="Status">
                                                        <li className="menu-item"
                                                            onClick={() => this.setState({toggleAlertDelete: true})}>
                                                            <Icon type="close"/> Supprimer
                                                        </li>
                                                    </Can>
                                                    <Can action={"report"} subject={this.props} modelName="Status">
                                                        <li className="menu-item">
                                                            <Icon type="report"/>
                                                            <Report _id={this.props.parentId._id}
                                                                    kind={"status"}
                                                                    handleReport={this.handleReport}
                                                                    title="le statut"/>
                                                        </li>
                                                    </Can>
                                                </ul>
                                            </Dropdown>
                                    ) : null
                                )}
                                <Modal toggle={this.state.editStatus}
                                       handleClose={() => this.setState({editStatus: false})}>
                                    <EditStatus key={this.props.parentId._id} {...this.props.parentId}
                                                handleClose={() => this.setState({editStatus: false})}/>
                                </Modal>
                                <Modal toggle={this.state.toggleAlertDelete}
                                       handleClose={() => this.setState({toggleAlertDelete: false})}>
                                    <Alert text="Voulez vous vraiment supprimer ce statut ?"
                                           handleDelete={this.handleDelete}
                                           handleClose={() => this.setState({toggleAlertDelete: false})}/>
                                </Modal>
                            </div>
                            <div className="status-container">
                                <ViewMore limit={limitHeight}>
                                    <DraftContentReader contentRaw={this.props.parentId.contentRaw} ref={this.editorRef} />
                                </ViewMore>
                            </div>
                        </div>
                        <div className="footer">
                            <Answers value={this.props.parentId.count.comment}/>
                            <Like
                                isLiked={this.props.parentId.isLiked}
                                value={this.props.parentId.count.like || 0}
                                likeType={"status"}
                                parentId={this.props.parentId._id}
                            />
                        </div>
                    <TimelineComments
                        commentsAllowed={this.props.parentId.commentsAllowed}
                        commentType={"status"}
                        parent={this.props.parentId}
                        ownerId={this.props.parentId.owner._id}
                        parentId={this.props.parentId._id}
                        handleReport={this.handleReportComment}
                    />
                </Fragment>
            </div>
        )
    }
}


CardStatus.defaultProps = {
    article: {
        owner: {
            _id: 0,
            slug: '',
            avatar: '',
            gender: 0
        },
        author: {
            _id: 0,
            slug: '',
            avatar: '',
            gender: 0
        },
        authorName: "",
        comment: {
            allowed: false
        },
        count: {
            like: 0,
            view: 0,
            comment: 0
        }
    }
};

const mapStateToProps = (state) => {
    return {
        currentUserUsername: state.currentUser.data && state.currentUser.data.username
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserStatus,
    deleteUserStatus,
    resetUserStatus,
    reportUserStatus,
    reportStatusComment
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CardStatus);
